import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
const projects = [{
  id: 1,
  title: "Elena & Julian",
  category: "Lake Como, Italy",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/wedding_elena_julian.png",
  aspect: "aspect-[3/4]"
}, {
  id: 2,
  title: "Sophia & Marcus",
  category: "Santorini, Greece",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/wedding_sophia_marcus.png",
  aspect: "aspect-[4/3]"
}, {
  id: 3,
  title: "Isabella & Liam",
  category: "Provence, France",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/wedding_isabella_liam.png",
  aspect: "aspect-square"
}, {
  id: 4,
  title: "Clara & Mateo",
  category: "Tuscany, Italy",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/wedding_clara_mateo.png",
  aspect: "aspect-[4/5]"
}, {
  id: 5,
  title: "Aria & Bennett",
  category: "Cotswolds, UK",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/wedding_aria_bennett.png",
  aspect: "aspect-[16/9]"
}, {
  id: 6,
  title: "Mia & Sebastian",
  category: "Amalfi Coast, Italy",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/wedding_mia_sebastian.png",
  aspect: "aspect-[3/4]"
}];
export default function OurWork() {
  return <section data-section-id="238030" id="the-featured-collections" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-foreground mb-6">
            The Featured Collections
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-2xl leading-relaxed">
            A curated selection of our most cherished wedding stories, capturing the soft-toned elegance and emotional resonance of every unique celebration.
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {projects.map((project, i) => <div key={project.id} data-index={i} className="break-inside-avoid">
              <Card className="relative overflow-hidden group border-0 rounded-md p-0 gap-0 bg-muted shadow-md">
                <div className={`w-full ${project.aspect} relative`}>
                  <img src={project.image} alt={project.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
                </div>
                
                {}
                <div className="absolute inset-0 bg-accent/80 translate-y-full group-hover:translate-y-0 transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] flex flex-col justify-end p-6 md:p-8">
                  <div className="transform translate-y-8 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-700 delay-100 ease-out">
                    <span className="text-accent-foreground/80 text-xs md:text-sm font-sans uppercase tracking-widest mb-3 block">
                      {project.category}
                    </span>
                    <h3 className="text-accent-foreground font-default text-2xl md:text-3xl font-light mb-8 leading-tight">
                      {project.title}
                    </h3>
                    <Button variant="outline" className="w-fit border-accent-foreground/20 text-accent-foreground hover:bg-accent-foreground hover:text-accent rounded-md px-6 py-6 h-auto font-sans uppercase tracking-wider text-xs" asChild>
                      <Link to="/CollectionsPage">
                        View Story <ArrowRight className="ml-3 size-4" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}